
export const getCommissionRate = (carrier: string): number => {
  switch (carrier) {
    case 'Travelers':
      return 0.12; // 12% for Travelers
    case 'Progressive':
      return 0.10; // 10% for Progressive
    default:
      return 0.15; // 15% for all other carriers
  }
};

export const calculateCommission = (premium: number, carrier: string): number => {
  return premium * getCommissionRate(carrier);
};

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);
};
